export interface SimpleProduct {
  name: string;
  type: number;
  id: string;
}
